export default __webpack_public_path__ + "static/media/hht2_ep04_book_wp_02.7ba48c61.jpg";